import { render, staticRenderFns } from "./DocumentManage.vue?vue&type=template&id=19ae3ea0&"
import script from "./DocumentManage.vue?vue&type=script&lang=js&"
export * from "./DocumentManage.vue?vue&type=script&lang=js&"
import style0 from "./DocumentManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports